export default __webpack_public_path__ + "static/media/caliopel.ef3896dc.jpg";